import { createAsyncThunk } from '@reduxjs/toolkit';


interface SendOtpParams {
  email: string;
}

export const sendOtp = createAsyncThunk<string, SendOtpParams, { rejectValue: string }>(
  'auth/login/loginWithEmail',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch {
        throw new Error('Invalid JSON response from server');
      }

      if (!response.ok) {
        if (response.status === 500) {
          throw new Error('Internal Server Error');
        }
        throw new Error(responseData?.message || 'An unknown error occurred');
      }

      return responseData.message;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  }
);

